import { useEffect, useLayoutEffect, useRef } from "react";
import { isProd } from "common/src/Env.bind";

const FLOATING_THRESHOLD = 0;

export function NpVideo({ screenSize, ab }) {
  const el = useRef(null);
  let id =
    screenSize < 2
      ? "np-video"
      : screenSize < 4
        ? "np-video-md"
        : "np-video-sm";

  if (ab < FLOATING_THRESHOLD) {
    id += "-floating";
  }

  if (typeof window !== "undefined") {
    useLayoutEffect(() => {
      if (ab >= FLOATING_THRESHOLD) {
        el.current.id = id;
      }
    }, [id]);
  }

  useEffect(() => {
    if (window.afm) {
      return;
    }
    if (window.initAdIds.includes(id)) {
      window.initAdIds = window.initAdIds.filter((i) => i !== id);
      return;
    }

    if (ab < FLOATING_THRESHOLD) {
      window["nitroAds"].createAd(id, {
        format: "floating",
      });
    } else {
      window["nitroAds"]?.createAd(id, {
        demo: !isProd,
        format: "video-nc",
        video: {
          // interval: 30,
          hidePlaylist: true,
        },
      });
    }
  }, [id]);

  if (ab < FLOATING_THRESHOLD) {
    return null;
  } else {
    return (
      <div
        ref={(ref) => (el.current = ref)}
        key={id}
        id={id}
        dangerouslySetInnerHTML={{ __html: "" }}
        suppressHydrationWarning
      />
    );
  }
}
